import { useEffect, useState } from 'react'
import { api } from '../services/api'

// FAR-74: load the Base Plans for a plant once, keyed by id, so the plan list
// can name the Base Plan each plan was built on. GET /plans returns only
// basePlanId; the label (when it was built, and by whom) lives on the Base
// Plan record.
//
// Returns {} until loaded, and on failure -- callers fall back to a neutral
// label rather than showing a half-rendered one.
export function useBasePlans(plantCode, version = 0) {
  const [byId, setById] = useState({})

  useEffect(() => {
    if (!plantCode) {
      setById({})
      return undefined
    }
    let cancelled = false
    api.get(`/base-plans?plant=${encodeURIComponent(plantCode)}`)
      .then((list) => {
        if (cancelled) return
        const map = {}
        for (const bp of Array.isArray(list) ? list : []) map[bp.id] = bp
        setById(map)
      })
      .catch(() => { if (!cancelled) setById({}) })
    return () => { cancelled = true }
  }, [plantCode, version]) // FAR-79: bump to refresh ("Used by" changes after a switch)

  return byId
}
